import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './text-panel.module.css';

function TextPanel(props) {
  const { children } = props;

  return (
    <section className={styles.panel}>
      {children}
    </section>
  );
}

TextPanel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default TextPanel;
